module.exports = __webpack_public_path__ + "static/media/star.7dc6e5d5.svg";